export default {
    blog_text_1: "Naše ",
    blog_text_2: "blogy",
    blog_text_3: "Ostatné články",

    p_packages_text_1: "FUNKCIE DOFFERO",
    p_packages_text_2: "Čo získam",
    p_packages_text_3: "Neobmedzené ponuky",
    p_packages_text_4: "Neobmedzený počet klientov",
    p_packages_text_5: "Vlastné",
    p_packages_text_6: "Nastav si vlastné farby v dizajne ponuky.",
    p_packages_text_7: "farebné kombinácie",
    p_packages_text_8:
        "Môžeš vytvoriť používateľov, ktorí majú prístup k tvojmu účtu.",
    p_packages_text_9: "Pod-účty",
    p_packages_text_10: "pre kolegov, či zamestnancov",
    p_packages_text_11:
        "Pridaj si recenzie svojich klientov, ktoré budú súčasťou ponuky.",
    p_packages_text_12: "Recenzie",
    p_packages_text_13: "tvojich klientov v ponuke",
    p_packages_text_14: "Ponuky",
    p_packages_text_15:
        "Ak chceš, môžeš si skryť naše logo v tvojich ponukách.",
    p_packages_text_16: "bez loga",
    p_packages_text_17: "DOFFERO",
    p_packages_text_18:
        "PREMIUM používateľom ponúkame možnosť vypracovania vzhľadu cenovej ponuky na mieru.",
    p_packages_text_19: "Vlastné šablóny",
    p_packages_text_20: "cenovej ponuky",
    p_packages_text_21:
        "Možnosť prepnúť ponuku do angličtiny, nemčiny a češtiny",
    p_packages_text_22: "Možnosť vložiť obrázky k položkám",
    p_packages_text_23: "Možnosť nahrať",
    p_packages_text_24:
        "Nahraj dokumenty alebo súbory, ktoré si môže tvoj zákazník stiahnuť v online ponuke.",
    p_packages_text_25: "dokumenty na stiahnutie",
    p_packages_text_26: "Možnosť nastaviť si rôzne meny - EUR, CZK, USD, GBP",
    p_packages_text_27: "Možnosť vytvárať cenové ponuky pod rôznymi firmami",
    p_packages_text_28: "Možnosť prepojiť DOFFERO® na",
    p_packages_text_29: "SuperFaktura.sk",
    p_packages_text_30: "Chcem sa zaregistrovať zadarmo",
    p_packages_text_31: "Tvoj aktuálny balík",
    p_packages_text_32:
        "DOFFERO je aktuálne zadarmo so všetkými funkciami. Žiadne háčiky.",
    p_packages_text_33: "a čo ceny?",
    p_packages_text_34: "DOFFERO je",
    p_packages_text_35: "aktuálne pre",
    p_packages_text_36: "všetkých zadarmo",

    register_text_1: "Čo ti vieme ponúknuť?", // This line corresponds to the commented-out subtitle
    register_text_2: "Čo oceníš na cenových ponukách DOFFERO?",
    register_text_3: "Očarujúci dizajn",
    register_text_4: "Krásny",
    register_text_5: "dizajn",
    register_text_6: "Viac nových zákaziek",
    register_text_7: "Rýchla",
    register_text_8: "tvorba",
    register_text_9: "Prepracované šablóny",
    register_text_10: "Prispôsobiteľná",
    register_text_11: "farebnosť",
    register_text_12: "Schválenie na 1 klik",
    register_text_13: "Schválenie",
    register_text_14: "na 1 klik",
    register_text_15: "na základe dotazníkov od našich používateľov",
    register_text_16:
        "Appku som pouzil na cca 10 ponuk a z toho 7 bolo úspešnych. Uvidime, ako to pojde dalej. :)",
    register_text_17: "Matej, programátor",

    register_text_19: "Ty si ešte nevyskúšal/a naše cenové ponuky ZADARMO?",
    register_text_20: "Zmeň to! Stačí sa registrovať alebo sa",
    register_text_21: "prihlás",
    register_text_22: "Meno a priezvisko",
    register_text_23: "Email",
    register_text_24: "Heslo",
    register_text_25: "8 znakov",
    register_text_26: "1 veľké písmeno",
    register_text_27: "1 číslica",
    register_text_28: "Vytvoriť účet",
    register_text_29: "Prečítaj si prosím podmienky",
    register_text_30: "spracovania osobných údajov",

    validation_text_1: "Meno je potrebný údaj.",
    validation_text_2: "Email je potrebný údaj.",
    validation_text_3: "Zadajte spravný format emailu.",
    validation_text_4: "Email už existuje.",
    validation_text_5: "Heslo je potrebný údaj.",
    validation_text_6: "Heslo musí obsahovať viac ako 8 znakov.",
    validation_text_7: "Treba udeliť súhlas.",
    validation_text_8: "Názov spoločnosti je potrebný údaj.",

    // Registrácia — onboarding kroky (0-6)
    reg_title_start: "Nastav si DOFFERO na komplet za menej ako 90 sekúnd",
    reg_subtext_start:
        "Vďaka tomu budeš vytvárať cenové ponuky rýchlo a jednoducho. Začni menom, e-mailom a heslom.",
    reg_email_label: "Emailová adresa",
    reg_login_link: "Prihlásiť sa",
    reg_terms_prefix: "Prečítal/a som si",
    reg_terms_link: "všeobecné obchodné podmienky",
    reg_terms_suffix: "a súhlasím s nimi",
    reg_continue: "Pokračovať",
    reg_consent_text: "Pokračovaním v registrácií súhlasím s",
    reg_consent_link: "Podmienkami spracovania osobných údajov",
    reg_users_bar_1: "DOFFERO dôveruje už viac ako",
    reg_users_bar_2: "používateľov",
    reg_step: "Krok",
    reg_step_back: "Krok späť",

    reg_s1_hello: "Ahoj",
    reg_s1_question: ". Podnikáš?",
    reg_s1_subtext:
        "Pomôž nám spoznať ťa lepšie. My ti na oplátku presne prispôsobíme DOFFERO.",
    reg_s1_type1_title: "Som podnikateľ",
    reg_s1_type1_desc: "Som živnostník alebo vlastním s.r.o.čku",
    reg_s1_type2_title: "Niesom podnikateľ",
    reg_s1_type2_desc: "Momentálne nepodnikám",

    reg_s2_title_company: "Ako sa volá tvoja spoločnosť?",
    reg_s2_title_brand: "Ako sa volá tvoja značka či projekt?",
    reg_s2_subtext_company:
        "Na základe jej názvu sa pokúsime nájsť údaje o spoločnosti, aby sme ti uľahčili vypisovanie.",
    reg_s2_subtext_brand:
        "Na základe názvu tvojej značky ti pripravíme profil v DOFFERO.",
    reg_s2_company_name: "Názov spoločnosti",
    reg_s2_brand_name: "Názov značky alebo projektu",
    reg_s2_more_info: "Viac údajov o firme",
    reg_s2_less_info: "Menej údajov o firme",
    reg_s2_street: "Ulica a číslo sídla firmy",
    reg_s2_zip: "PSČ sídla firmy",
    reg_s2_city: "Mesto sídla firmy",
    reg_s2_vat_payer: "Som platca DPH",
    reg_s2_vat_increase_1: "Navýšiť ceny s",
    reg_s2_vat_increase_2: "DPH",
    reg_s2_verified: "Overené",
    reg_s2_card_address: "Adresa",
    reg_s2_card_company: "spoločnosti",
    reg_err_dic_cz: "DIČ musí byť v tvare CZ + 8 až 10 číslic.",
    reg_err_dic_sk: "DIČ musí mať 10 číslic.",
    reg_err_dph: "IČ DPH musí byť v tvare napr. SK1234567890.",
    reg_err_company_used: "Tento názov spoločnosti sa už používa",

    reg_s3_title_company: "Prispôsob si DOFFERO \n presne pre svoju firmu",
    reg_s3_title_brand: "Prispôsob si DOFFERO \n presne pre svoju značku",
    reg_s3_subtext_1: "Vďaka týmto informáciám získaš",
    reg_s3_subtext_2: "s cenovými ponukami profesionálne výsledky.",
    reg_s3_business_type: "Typ podnikania",
    reg_s3_brand_area: "Oblasť tvojej značky",
    reg_select: "Vyberte",
    reg_s3_specify: "Vieš konkretizovať?",
    reg_s3_company_size: "Veľkosť firmy",
    reg_s3_how_many: "Koľko vás je?",
    reg_emp_1: "1 človek",
    reg_emp_2: "2-4 ľudia",
    reg_emp_3: "5-10 ľudí",
    reg_emp_4: "10 - 50 ľudí",
    reg_emp_5: "50 a viac ľudí",
    reg_biz_1: "Stavebníctvo a remeselníctvo",
    reg_biz_2: "Digitálna / marketingová agentúra",
    reg_biz_3: "Maloobchod a predaj",
    reg_biz_4: "Dizajn a grafika",
    reg_biz_5: "IT, programovanie a softvér",
    reg_biz_6: "Foto / video produkcia",
    reg_biz_7: "Finančné poradenstvo a poisťovníctvo",
    reg_biz_8: "Iné",
    reg_err_business: "Vyberte aspoň jeden typ podnikania",
    reg_err_other_business: "Prosím, zadajte hodnotu pre iné podnikanie",
    reg_err_employees: "Vyberte počet zamestnancov",

    reg_s4_title: "Vylaď si vzhľad ponúk",
    reg_s4_subtext_company:
        "Nastav si logo, URL a farbu, aby ešte lepšie predávali a reprezentovali tvoju firmu. Všetky nastavenia si môžeš neskôr upraviť.",
    reg_s4_subtext_brand:
        "Nastav si logo, URL a farbu, aby ešte lepšie predávali a reprezentovali tvoju značku. Všetky nastavenia si môžeš neskôr upraviť.",
    reg_s4_logo: "Logo firmy",
    reg_s4_optional: "(Nepovinné)",
    reg_s4_logo_placeholder: "vlož, alebo nahraj logo firmy",
    reg_s4_remove: "Odstrániť",
    reg_s4_url: "Tvar URL",
    reg_s4_color: "Farba ponúk",
    reg_s4_custom_colors: "Vlastné farby",
    reg_s4_basic_colors: "Základné farby",
    reg_s4_toast_size: "Obrázok musí byť menší ako 2 MB!",
    reg_s4_toast_type: "Je možné nahrať iba obrázok!",
    reg_s4_preview_title: "Cenová ponuka",
    reg_s4_preview_item1: "Projektové zadanie",
    reg_s4_preview_item2: "Wireframes a dizajn",
    reg_s4_preview_item3: "Projektovy manazment",
    reg_s4_preview_total: "Celková cena",
    reg_err_url: "Prosím, zadajte URL adresu spoločnosti",
    reg_err_url_taken: "Táto URL adresa spoločnosti je už obsadená",

    reg_s5_title: "Vyber si svoj balík",
    reg_s5_subtext:
        "Vyber si balík, ktorý tvojmu podnikaniu a procesom vyhovuje najviac.",

    reg_s6_status_1: "Vytvárame tvoj DOFFERO účet",
    reg_s6_status_2: "Nastavujeme vzhľad tvojich ponúk",
    reg_s6_status_3: "Vytvárame tvoju prvú (ukážkovú) ponuku",

    login_text_1: "Doffero",
    login_text_2: "Vitaj s5!",
    login_text_3: "Nemáš ešte účet?",
    login_text_4: "Zaregistruj sa",
    login_text_5: "Zabudnuté heslo?",
    login_text_6: "Prihlásiť sa",
};
